namespace Solovis.Reports.Parameters.Stats {

    export interface StatsOtherOptions {
        showHybridAnnCumColumns?: "Default" | "Yes" | "No" | null | undefined;
        showTwrActiveReturnColumns?: "Default" | "Yes" | "No" | null | undefined;

        autoGroupInCompositeMode?: "Default" | "Yes" | "No" | null | undefined;

        useCompositeSelectionSetLabelForAll?: "Default" | "Yes" | "No" | null | undefined;

        outputFilter?: StatsOutputFilter;
    }

    export interface StatsOutputFilter {
        fullLabelPaths?: string[];
        maxGroupDepth?: number;

        includeGroups?: boolean;
    }

    export class StatsOtherOptionsParameterControl extends Solovis.UI.BaseControl {

        public static hasNewRender = true;
        private _otherOptions: StatsOtherOptions;

        private _otherLabel;
        private _otherEditLink;

        constructor(options) {
            super(options);

            this._otherOptions = (typeof options.initialValue != "undefined") ? options.initialValue : null;
        }


        public doRender() {
            if (this.options.renderMode === 'modern') {
                this.doRenderNew();
            } else {
                this.doRenderClassic();
            }
        }

        private async doRenderNew(){
            await Solovis.UX.Utils.placeComponent("ConfigureControl", this.container[0], {onClick:(event)=>{this._showStatsOtherOptionsEditor()}})

        }


        private doRenderClassic() {
            let self = this;

            this._otherLabel = $("<a>").text("Other Options").appendTo(this.container);
            this._otherLabel.click(function () {
                self._showStatsOtherOptionsEditor();
            });

            this._otherEditLink = $("<a>").appendTo(this.container)
                .css("padding-left", "5px")
                .html("<span class='fa fa-pencil'></span>");
            this._otherEditLink.click(function () {
                self._showStatsOtherOptionsEditor();
            });
        }


        private _showStatsOtherOptionsEditor() {
            let editorDialog = new StatsOtherOptionsEditorDialog({
                otherOptions: this._otherOptions,
                saveCallback: (newOtherOptions) => {
                    this.setParameterValue(newOtherOptions);
                }
            });

            editorDialog.show();            
        }


        public _setCurrentOtherOptions(newOtherOptions) {
            this._otherOptions = newOtherOptions;
        }

        public setParameterValue(newValue, more?) {
            Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
                this, StatsOtherOptionsParameterControl, this._setCurrentOtherOptions, newValue, more);
        }

        public getParameterValue() {
            return Solovis.deepCopy(this._otherOptions);
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }
    }

    export class StatsOtherOptionsEditorDialog {

        private _otherOptions: StatsOtherOptions;
        private _saveCallback;

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;

        public constructor(options) {
            this._otherOptions = options.otherOptions ? options.otherOptions : {};
            this._saveCallback = options.saveCallback;
        }

        public show() {
            let otherOptions = this._otherOptions;

            let formBuilderDiv = $("<div>");
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv,
                width: 800,
                labelColumnWidth: 245
            });
            this._formBuilder = formBuilder;

            let defaultYesNoOptions = [
                { text: "Default", value: "Default" },
                { text: "Yes", value: "Yes" },
                { text: "No", value: "No" }
            ];

            formBuilder.addEntry({
                name: "performance",
                label: "Performance",
                isGroupHeader: true,
            });

            formBuilder.addEntry({
                name: "showHybridAnnCumColumns",
                label: "Show Hybrid Ann./Cum. Columns",

                help: "If annualized and cumulative returns are available, a hybrid ann./cum. column should be used to display result.",

                initialValue: otherOptions.showHybridAnnCumColumns ? otherOptions.showHybridAnnCumColumns : "Default",

                editor: {
                    type: "select",
                    selectOptions: {
                        data: defaultYesNoOptions
                    }
                }
            });

            formBuilder.addEntry({
                name: "showTwrActiveReturnColumns",
                label: "Show TWR Active Return Columns",

                help: "If TWR for line item and benchmark is available, show active return columns (LineItemTWR - BenchmarkTWR).",

                initialValue: otherOptions.showTwrActiveReturnColumns ? otherOptions.showTwrActiveReturnColumns : "Default",

                editor: {
                    type: "select",
                    selectOptions: {
                        data: defaultYesNoOptions
                    }
                }
            });


            formBuilder.addEntry({
                name: "grouping",
                label: "Grouping",
                isGroupHeader: true,
            });

            formBuilder.addEntry({
                name: "autoGroupInCompositeMode",
                label: "Auto-Group In Composite Mode",

                help: "If doing a composite analysis, the table will automatically be set to group by all if grouping is not already enabled.",

                initialValue: otherOptions.autoGroupInCompositeMode ? otherOptions.autoGroupInCompositeMode : "Default",

                editor: {
                    type: "select",
                    selectOptions: {
                        data: defaultYesNoOptions
                    }
                }
            });

            formBuilder.addEntry({
                name: "useCompositeSelectionSetLabelForAll",
                label: "Use Composite Selection Set Label For 'All'",

                help: "If doing a composite analysis, the 'All' row asset label will instead use label for composite selection set.",

                initialValue: otherOptions.useCompositeSelectionSetLabelForAll ? otherOptions.useCompositeSelectionSetLabelForAll : "Default",

                editor: {
                    type: "select",
                    selectOptions: {
                        data: defaultYesNoOptions
                    }
                }
            });

            formBuilder.addEntry({
                name: "compositeOutputFilter",
                label: "Composite Output Filter",
                isGroupHeader: true,
            });

            formBuilder.addEntry({
                name: "enableOutputFilter",
                label: "Enable Output Filter",

                help: "If enabled, only the items requested will be included in output. By default, nothing will be included.",

                initialValue: otherOptions.outputFilter ? true : false,

                editor: {
                    type: "bool"
                }
            });

            formBuilder.addEntry({
                name: "outputFilter.includeGroups",
                label: "Include Groups",

                help: "If checked, all group rows will be included.",

                initialValue: (otherOptions.outputFilter && otherOptions.outputFilter.includeGroups) ? true : false,

                editor: {
                    type: "bool"
                },

                isVisible: (formEntry) => {
                    return !!formEntry.formBuilder.getValueByName("enableOutputFilter");
                }
            });

            formBuilder.addEntry({
                name: "outputFilter.maxGroupDepth",
                label: "Max Group Depth",

                help: "If specified, only groups within the specified depth will be pulled in.",

                initialValue: otherOptions.outputFilter ? otherOptions.outputFilter.maxGroupDepth : null,

                editor: {
                    type: "integer"                    
                },

                isVisible: (formEntry) => {
                    return !!formEntry.formBuilder.getValueByName("enableOutputFilter")
                        && !!formEntry.formBuilder.getValueByName("outputFilter.includeGroups");
                }
            });

            let fullLabelPathText = "";
            if (otherOptions.outputFilter && otherOptions.outputFilter.fullLabelPaths) {
                fullLabelPathText = otherOptions.outputFilter.fullLabelPaths.join("\n");
            }

            formBuilder.addEntry({
                name: "outputFilter.fullLabelPathText",
                label: "Full Label Paths",

                initialValue: fullLabelPathText,

                help: "Use one 'Full Label Path' per line to include data. Remember to disable grouping to see lines where the "
                    + " parent group is not included.",

                editor: {
                    type: "textarea",

                    textareaOptions: {
                        width: "500px",
                        height: "100px"
                    }
                },

                isVisible: (formEntry) => {
                    return !!formEntry.formBuilder.getValueByName("enableOutputFilter");
                }
            });

            formBuilder.setupDone();

            formBuilder.showAsDialog({
                title: "Edit Other Options",

                desiredWidth: 800,
                desiredHeight: 1000,

                showSaveCancel: true,
                saveButtonText: "OK",

                saveCallback: () => {
                    let newOptions = this._getNewOtherOptions();

                    this._saveCallback(newOptions);

                    return true;
                }
            });
        }

        private _getNewOtherOptions() {
            let newOtherOptions: StatsOtherOptions = {};          

            let showHybridAnnCumColumns = this._formBuilder.getValueByName("showHybridAnnCumColumns");
            if (showHybridAnnCumColumns !== "Default") {
                newOtherOptions.showHybridAnnCumColumns = showHybridAnnCumColumns;
            }

            let showTwrActiveReturnColumns = this._formBuilder.getValueByName("showTwrActiveReturnColumns");
            if (showTwrActiveReturnColumns !== "Default") {
                newOtherOptions.showTwrActiveReturnColumns = showTwrActiveReturnColumns;
            }

            let autoGroupInCompositeMode = this._formBuilder.getValueByName("autoGroupInCompositeMode");
            if (autoGroupInCompositeMode !== "Default") {
                newOtherOptions.autoGroupInCompositeMode = autoGroupInCompositeMode;
            }

            let useCompositeSelectionSetLabelForAll = this._formBuilder.getValueByName("useCompositeSelectionSetLabelForAll");
            if (useCompositeSelectionSetLabelForAll !== "Default") {
                newOtherOptions.useCompositeSelectionSetLabelForAll = useCompositeSelectionSetLabelForAll;
            }

            if (this._formBuilder.getValueByName("enableOutputFilter")) {
                let outputFilter: StatsOutputFilter = {};

                if (this._formBuilder.getValueByName("outputFilter.includeGroups")) {
                    outputFilter.includeGroups = true;

                    let maxGroupDepth = this._formBuilder.getValueByName("outputFilter.maxGroupDepth");
                    if (Solovis.isNotNull(maxGroupDepth)) {
                        outputFilter.maxGroupDepth = maxGroupDepth;
                    }
                }

                let fullLabelPathText = this._formBuilder.getValueByName("outputFilter.fullLabelPathText");
                if (fullLabelPathText) {
                    let fullLabelPaths = [];

                    let fullLabelPathLines = fullLabelPathText.split("\n");
                    for (let line of fullLabelPathLines) {
                        let trimmedLine = line.trim();
                        if (trimmedLine) {
                            fullLabelPaths.push(trimmedLine);
                        }
                    }

                    if (!_.isEmpty(fullLabelPaths)) {
                        outputFilter.fullLabelPaths = fullLabelPaths;
                    }
                }

                newOtherOptions.outputFilter = outputFilter;
            }

            return newOtherOptions;
        }
    }

}